import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import Iconoclast from '../../../../Iconoclast';
import photoPlaceHolder from '../../../../../assets/images/photo-loading.svg';
import photoPlaceHolderHoriz from '../../../../../assets/images/photo-place-holder-horiz.svg';
import dataModel from '../../../../../models/DataModel';
import FileUtil from '../../../../../helpers/FileUtil/FileUtil';
import ImageTools from '../../../../../helpers/ImageTools';
import './FileCard.scss';

export class FileCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { menu: null };
  }

  componentDidMount() {
    if (this.props.uploadInProgress) {
      this.animateProgress();
    }
    this.handleSizing();
  }

  componentDidUpdate(prevProps) {
    const nextProps = this.props;

    if (prevProps.attachment != nextProps.attachment) {
      this.setState({ menu: this.state.menu });
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  handleSelection(e) {
    e.stopPropagation();
    const { 
      attachment,
    } = this.props;

    if (!this.props.isPhoto && this.props.handleFileSelected) {
      this.props.handleFileSelected(attachment);
    }
    else {
      this.props.handlePhotoSelection(attachment);
    }
  }

  handleSizing() {
    if (this.element) {
      const parent = this.element.parentElement;
      if (parent) {
        const rect = parent.getBoundingClientRect();
        if (this.props.hideName) {
          const width = rect.width;
          const height = Math.floor(width * 102 / 120);
          this.setState({ height: height });
        }
        else {
          const height = rect.height;
          const width = Math.floor(height * 120 / 102);
          this.setState({ width: width });
        }
      }
    }
  }

  animateProgress() {
    if (!this.interval) {
      let width = 0;
      const self = this;
      this.interval = setInterval(() => {
        if (self.progressElement && self.loadingElement) {
          let parentRect = self.loadingElement.getBoundingClientRect();

          width++;
          if (width >= parentRect.width) {
            width = 0;
          }
          self.setState({ progressWidth: width });
        }
      }, this.props.mobileBridge.isMobile ? 20 : 5);
    }  
  }

  handleSetLIElement(element) {
    if (element) {
      this.loadingElement = element;
    }
    if (this.progressElement && this.loadingElement && !this.interval) {
      this.animateProgress();
    }
  }

  handleSetPElement(element) {
    if (element) {
      this.progressElement = element;
    }
    if (this.progressElement && this.loadingElement && !this.interval) {
      this.animateProgress();
    }
  }

  render() {
    const { 
      attachment, 
      hideName, 
      uploadInProgress, 
      dark,
      noBorder,
      extensionType,
      completionStepId,
    } = this.props;
    let src;    
    if (uploadInProgress) {
      src = hideName ? photoPlaceHolderHoriz : photoPlaceHolder;
    }
    else if (attachment.prefetchedImage && dataModel.isOffline) {
      src = attachment.prefetchedImage;
    }
    else if (attachment.upload && (attachment.upload instanceof Blob)) {
      src = URL.createObjectURL(attachment.upload);
    }
    else {
      src = this.props.mobileBridge.isMobile ?
        (attachment._thumbnailForRetention && attachment._thumbnailForRetention.src ?
          attachment._thumbnailForRetention.src : attachment.upload_thumb) : attachment.upload_small || attachment.upload;
    }
        /*
    let src = uploadInProgress
      ? (hideName ? photoPlaceHolderHoriz : photoPlaceHolder)
      : (attachment.prefetchedImage && dataModel.isOffline ? attachment.prefetchedImage : (attachment.upload && (attachment.upload.name || attachment.upload.size) ? URL.createObjectURL(attachment.upload) : attachment.upload));
*/

    if (completionStepId && FileUtil.getAcceptedExtensionsByType(extensionType) != FileUtil.extensionTypes.photoTypes) {
      src = ImageTools.getIconForFile(extensionType, 'grey-filled');
    }

    const progressStyle = this.state.progressWidth
      ? { width: this.state.progressWidth }
      : {};

    let indicator, offlineIcon = null;
    if (uploadInProgress) {
      indicator = <div
        className="loading-indicator"
        id={'loading-indicator-default'}
        ref={element => {
          this.handleSetLIElement(element);
        }}
      >
        <div
          className="progress-indicator"
          id={'progress-indicator-default'}
          ref={element => {
            this.handleSetPElement(element);
          }}
          style={progressStyle}
        />
      </div>;

    }
    if(attachment && attachment._dirty){
      offlineIcon = <div className='offline-icon'>
        <Iconoclast type='offline-double' color='#9b9b9b' height='16px' width='21px'/>
      </div>;
    }
    let titleImage=attachment &&  attachment.name?attachment.name.split('/'):'';
    return (
      <div className={'file-card' + (noBorder ? ' no-border' : '') + (dark ? ' dark' : '') +(uploadInProgress ? ' uploading' : '')} onClick={attachment && attachment._dirty?null:this.handleSelection}>
        <img className="image-holder" src={src} alt="attachment" />
        <div className="image-title">{attachment ? titleImage[titleImage.length-1] : ''}</div>
        <div className="holder">
          {indicator}
        </div>
        {offlineIcon}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    mobileBridge: dataModel.mobileBridge,
  };
};

export default connect(mapStateToProps)(FileCard);



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/PhotoUpload/TaskCompletionStepPhotoGrid/FileCard/index.js